<template>
  <div>
    <head-nav-bar title="订单详情" :fixed="true">
      <template slot="right">
        <van-dropdown-menu class="custom-dropdown">
          <van-dropdown-item title="…" ref="item">
            <van-cell-group class="order-drop-menu">
              <van-cell
                title="换台"
                is-link
                @click="changeTable"
                v-if="
                  currentTable &&
                    currentTable.OrderStatus != 4 &&
                    orderInfo.Status != 4
                "
              />
              <van-cell
                title="取消桌台"
                is-link
                @click="cancelTable"
                v-if="
                  currentTable &&
                    currentTable.OrderStatus != 4 &&
                    orderInfo.Status != 4
                "
              />
            </van-cell-group>
          </van-dropdown-item>
        </van-dropdown-menu>
      </template>
    </head-nav-bar>
    <div class="mt-header-nav confirm-box">
      <cell-box style="padding: 5px 0;" :column="2">
        <cell-item label="联系人：">
          <div slot="value">
            {{ orderInfo.Contact }}
            <van-tag type="danger" v-if="orderInfo.Status == 4" plain>{{
              orderInfo.StatusName
            }}</van-tag>
            <van-tag
              type="success"
              plain
              v-else-if="orderInfo.Status != 0 && orderInfo.Status != 13"
              >{{ orderInfo.StatusName }}</van-tag
            >

            <van-tag color="#f90" plain v-else>{{
              orderInfo.StatusName
            }}</van-tag>
          </div>
        </cell-item>
        <cell-item label="就餐人数：" :value="orderInfo.PersonCount" />
        <cell-item label="桌台：" :value="tableName" />
        <cell-item label="订单号：" :value="orderInfo.No" />
        <cell-item label="电话：" :value="orderInfo.Phone" />
        <cell-item
          label="会员卡："
          v-if="orderInfo.MemberName"
          :value="orderInfo.MemberName"
        />
        <cell-item v-if="Number(orderInfo.Discount) > 0" label="折扣：">
          <template slot="value">
            {{ orderInfo.Discount }}
            <van-button
              size="mini"
              type="danger"
              @click="cancelDiscount"
              v-if="orderInfo.Status != 4 && orderInfo.Status != 2"
            >
              取消折扣</van-button
            >
          </template>
        </cell-item>
        <cell-item
          label="订餐时间："
          style="gridColumn:span 2;"
          :value="orderInfo.CheckInTime"
          v-if="orderInfo.CheckInTime"
        />
        <cell-item
          label="备注："
          style="gridColumn:span 2;"
          :value="orderInfo.OrderRemark"
          v-if="orderInfo.OrderRemark"
        />
      </cell-box>
      <h3 class="selected-title">
        下单菜品
      </h3>
      <div class="select-foods detail-select-table">
        <template v-for="item in orderFoodList">
          <van-card :key="item.DishId">
            <template #price>
              <div style="color:#555">
                <span>&yen;{{ item.UnitPrice }} x {{ item.Quantity }}</span>
                <span
                  v-if="Number(orderInfo.Discount) > 0"
                  class="discount-amount"
                  >(折扣金额：&yen;{{ item.DiscountPrice }})</span
                >
                <van-tag type="success" v-if="item.HadPay">已付款</van-tag>
              </div>
            </template>
            <template #title>
              <div class="food-title">
                <span>
                  {{ item.AccountItemName }}
                  <span
                    v-if="item.PracticeDesc || item.CookingMethodDesc"
                    class="method-txt"
                  >
                    「做法」{{ item.PracticeDesc }}{{ item.CookingMethodDesc }}
                  </span>
                  <span
                    v-if="
                      item.IsUnconfirmed &&
                        orderInfo.Status != 13 &&
                        orderInfo.Status != 0 &&
                        orderInfo.Status != 4
                    "
                    ><van-tag type="danger" mark plain>待确认</van-tag></span
                  >
                  <span v-if="item.IsPack">
                    <van-tag color="#f60" @click="openPack(item)"
                      >套餐&nbsp;<van-icon
                        :name="
                          openKeys.includes(item.DishId) ||
                          openKeys.includes(item.Id)
                            ? 'arrow-up'
                            : 'arrow-down'
                        "
                    /></van-tag>
                  </span>
                </span>
                <span>
                  <van-button
                    type="info"
                    size="mini"
                    @click="changePrice(item)"
                    :disabled="
                      (currentTable && currentTable.OrderStatus == 4) ||
                        orderInfo.Status == 4
                    "
                    >改价</van-button
                  >
                  <van-button
                    type="warning"
                    size="mini"
                    @click="returnDish(item)"
                    :disabled="
                      (currentTable && currentTable.OrderStatus == 4) ||
                        orderInfo.Status == 4
                    "
                    >退菜</van-button
                  >
                </span>
              </div>
            </template>
            <template #num>
              <span style="color:#f00"> &yen;{{ item.FinalPrice }}</span>
            </template>
            <template v-if="item.IsPack" #footer>
              <ul
                class="pack-detail"
                :class="{
                  'pack-detail-open':
                    openKeys.includes(item.DishId) ||
                    openKeys.includes(item.Id),
                }"
              >
                <li v-for="pack in item.PackDetails" :key="pack.Id">
                  {{ pack.Name }} x {{ pack.Quantity }}
                </li>
              </ul>
            </template>
          </van-card>
        </template>
      </div>
      <van-goods-action>
        <div slot="default" class="price-info">
          <van-row>
            <van-col :span="12">
              消费：<em class="price">&yen; {{ orderInfo.TotalAmount }}</em>
            </van-col>
            <van-col :span="12">
              折后：<em class="price">&yen; {{ orderInfo.FinalAmount }}</em>
            </van-col>
          </van-row>

          <van-row>
            <van-col :span="12">
              抹零：<em class="price"
                >&yen; {{ orderInfo.FreeRemnantAmount }}</em
              >
            </van-col>
            <van-col :span="12">
              付款：<em class="price">&yen; {{ orderInfo.PayAmount }}</em>
            </van-col>
          </van-row>
        </div>
        <van-goods-action-button
          type="warning"
          text="结账"
          @click="chekout"
          :disabled="
            (currentTable && currentTable.OrderStatus == 4) ||
              orderInfo.Status == 4
          "
        /><van-goods-action-button
          type="danger"
          text="加菜"
          @click="addFood"
          :disabled="
            (currentTable && currentTable.OrderStatus == 4) ||
              orderInfo.Status == 4
          "
        />
      </van-goods-action>
    </div>
    <TableOperate
      ref="TableOperate"
      :dishTables="orderInfo && orderInfo.DishTables"
      :orderId="orderId"
      @update="getDetail"
    ></TableOperate>
    <ChangeTable
      ref="ChangeTable"
      :orderId="orderId"
      @update="tableId => updateDetail(tableId)"
    ></ChangeTable>
  </div>
</template>

<script>
import "./restarant.less";
import { CellBox, CellItem } from "@/components/cell";
import restaurantManageApi from "@/api/restaurantManage.js";
import {
  Cell,
  CellGroup,
  Field,
  Button,
  Card,
  Tag,
  Icon,
  Dialog,
  Toast,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  DropdownMenu,
  DropdownItem,
  Notify,
  Row,
  Col,
} from "vant";
import restaurantApi from "@/api/restaurant.js";
import TableOperate from "./TableOperate.vue";
import ChangeTable from "./ChangeTable.vue";
import { accAdd } from "@/utils/common";
export default {
  name: "CreateOrder",
  components: {
    CellBox,
    CellItem,
    TableOperate,
    ChangeTable,
    [Row.name]: Row,
    [Col.name]: Col,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Toast.name]: Toast,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Card.name]: Card,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [Button.name]: Button,
    [Dialog.Component.name]: Dialog.Component,
    [GoodsAction.name]: GoodsAction,
    [GoodsActionIcon.name]: GoodsActionIcon,
    [GoodsActionButton.name]: GoodsActionButton,
  },
  data() {
    return {
      orderId: "",
      tableId: "",
      orderInfo: {},
      orderFoodList: [],
      tableName: "",
      total: {
        Quantity: 0,
        TotalPrice: 0,
      },
      openKeys: [],
      currentTable: {}, //当前桌台
    };
  },
  created() {
    this.orderId = this.$route.query.orderId;
    this.tableId = this.$route.query.tableId;
    if (this.orderId) {
      this.getDetail();
    } else {
      const _this = this;
      Dialog.alert({
        message: "暂无订单！",
        theme: "round-button",
      }).then(() => {
        _this.$router.push({
          name: "restarantManageIndex",
        });
      });
    }
  },
  methods: {
    init() {
      let num = 0;
      this.orderFoodList.forEach(item => {
        num = accAdd(num, item.Quantity);
      });
      this.total.Quantity = num;
    },
    updateDetail(tableId) {
      this.tableId = tableId;
      const patnname = window.location.pathname;
      const search = "orderId=" + this.orderId + "&tableId=" + tableId;
      window.history.pushState({}, 0, patnname + "?" + search);
      this.getDetail();
    },
    getDetail() {
      restaurantApi.getOrderDetail({ Id: this.orderId }).then(res => {
        this.orderInfo = res.Data;
        this.currentTable = res.Data.DishTables.find(
          item => item.TableId === this.tableId,
        );
        this.orderFoodList = this.currentTable.DishAccounts;
        this.tableName = this.currentTable.TableName;
        this.total.TotalPrice = this.orderInfo.TotalAmount;
        this.init();
      });
    },
    openPack(item) {
      let id = item.Id ? item.Id : item.DishId;
      if (this.openKeys.includes(id)) {
        this.openKeys = this.openKeys.filter(el => el != id);
      } else {
        this.openKeys.push(id);
      }
    },
    addFood() {
      this.$router.push({
        name: "restarantManageOrderFood",
        query: {
          orderId: this.orderId,
          tableId: this.tableId,
        },
      });
    },
    changePrice(item) {
      this.$refs.TableOperate.onShow(item, 1);
    },
    returnDish(item) {
      this.$refs.TableOperate.onShow(item, 2);
    },
    changeTable() {
      //换台
      this.$refs.ChangeTable.onShow(this.currentTable);
    },
    cancelTable() {
      const { orderId, currentTable, $router } = this;
      //取消桌台
      Dialog.confirm({
        title: "确认取消桌台【" + this.tableName + "】吗？",
      })
        .then(() => {
          restaurantManageApi
            .cancelOrder({
              Id: orderId,
              TableIds: [currentTable.TableId],
            })
            .then(() => {
              Notify({ type: "success", message: "操作成功" });
              $router.push({ name: "restarantManageIndex" });
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    cancelDiscount() {
      const _this = this;
      Dialog.confirm({
        title: "确定取消折扣吗？",
      }).then(() => {
        restaurantManageApi
          .discount({
            Id: _this.orderId,
            Discount: 0,
            IsPreview: false,
          })
          .then(() => {
            Notify({ type: "success", message: "操作成功" });
            _this.getDetail();
          });
      });
    },
    chekout() {
      const openTableList = this.orderInfo.DishTables.filter(
        el => el.Status != 2,
      );

      if (openTableList.length > 1) {
        this.$refs.TableOperate.onShow(this.currentTable, 3);
      } else {
        this.$router.push({
          name: "restarantManageCheckout",
          query: {
            orderId: this.orderId,
            tableIds: this.currentTable.TableId,
          },
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.detail-select-table {
  height: calc(100vh - 250px);
  padding-bottom: 0;
}
.price-info {
  font-size: 13px;
  width: 50%;
  padding-left: 5px;

  .price {
    color: #f00;
  }
}
.custom-dropdown /deep/.van-dropdown-menu__title::after {
  display: none;
}
.discount-txt {
  float: right;
  margin-top: 3px;
  margin-right: 5px;
}
.discount-amount {
  margin-left: 10px;
  color: #f60;
  font-size: 12px;
}
</style>
